import React, { FC, PropsWithChildren } from 'react';
import { I18nextProvider } from 'react-i18next';

import { FeatureProvider } from 'context/FeatureContext';

import QueryClientProvider from 'utility/Provide/QueryClientProvider';
import i18n from 'utility/Translate/I18n';

const ProviderWrapper: FC<PropsWithChildren> = ({ children }) => (
    <QueryClientProvider>
        <FeatureProvider>
            <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
        </FeatureProvider>
    </QueryClientProvider>
);

export default ProviderWrapper;
